import useNotification from "utils/hooks/useNotification";
import useCommentsApi from "../hooks/useCommentsApi";
import TooltipButton from "views/Documents/components/TooltipButton";
import { MdDelete } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";

interface RemoveButtonPropsTypes {
  id?: ID;
  refetch?: () => void;
}

export default function RemoveButton({ id, refetch }: RemoveButtonPropsTypes) {
  const { t } = useTranslation();
  const { deleteComment } = useCommentsApi();
  const { notificationError } = useNotification();

  const confirmDelete = (id: ID) => {
    Modal.confirm({
      title: t("Delete comment"),
      content: t("Are you sure about delete this comment?"),
      okText: t("Yes"),
      okType: "danger",
      onOk: () => handleOk(id),
    });
  };

  const handleOk = async (id: ID) => {
    const response = await deleteComment({
      variables: {
        id,
      },
    });

    const errors = response?.data?.deleteComment?.errors;
    notificationError(errors);

    refetch!();
  };

  return (
    <TooltipButton
      variant="delete"
      placement="top"
      handleOnClick={() => confirmDelete(id)}
      icon={<MdDelete />}
    />
  );
}
